<template>
  <teleport to="body">
    <pdl-dialog
      id="customization-reset-selections-dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :visible="isVisible"
      :title="$t('product.fdp.customizable.colorThemes.modal.title')"
      :z-index="9999"
      @opened="focusTrapDialog"
      @keydown="handleKeydown"
    >
      <p
        class="mb-2"
        qaid="customization-reset-selections-body-text"
        v-text="$t('product.fdp.customizable.colorThemes.modal.body')"
      />
      <div class="buttons buttons--right">
        <pdl-button alert qaid="customization-reset-selections-button" @click="$emit('reset-selections')">
          {{ $t('product.fdp.customizable.colorThemes.modal.button.confirm') }}
        </pdl-button>
        <pdl-button secondary qaid="customization-reset-selections-cancel-button" @click="$emit('cancel-reset')">
          {{ $t('product.fdp.customizable.colorThemes.modal.button.discard') }}
        </pdl-button>
      </div>
    </pdl-dialog>
  </teleport>
</template>

<script>
import {mapMutations} from 'vuex';
import {PdlDialog} from '@pedal/pdl-dialog';
import {PdlButton} from '@pedal/pdl-button';
import {focusTrap, getAllFocusableElements} from '@/utils/accessibility/a11y-utils';

export default {
  components: {PdlButton, PdlDialog},
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['reset-selections', 'cancel-reset'],

  data() {
    return {
      focusableElements: [],
    };
  },
  watch: {
    isVisible(val) {
      this.setIsDialogOpen(val);
    },
  },
  methods: {
    ...mapMutations('bikeCustomization', ['setIsDialogOpen']),
    async focusTrapDialog() {
      const dialog = document.querySelector('#customization-reset-selections-dialog');
      this.focusableElements = [...getAllFocusableElements(dialog)];
    },
    handleKeydown(event) {
      focusTrap(event, this.focusableElements);
    },
  },
};
</script>

<style lang="scss" scoped>
.pdl-dialog {
  z-index: 9999;
}
</style>
